import { useMemo } from 'react';
import { SchedulingConfirm } from './schedulingConfirm/SchedulingConfirm';
import { SchedulingDateTime } from './schedulingDateTime/SchedulingDateTime';
import { SchedulingDoctorsList } from './schedulingDoctorsList/SchedulingDoctorsList';
import { SchedulingStepsInterface } from './SchedulingInterface';
import { SchedulingPayment } from './schedulingPayment/SchedulingPayment';
import { SchedulingTypeAppointmentList } from './schedulingTypeAppointmentList/schedulingTypeAppointmentList';
import { SchedulingListUser } from './schedulingUserList/SchedulingUserList';
import { useTranslation } from 'react-i18next';
import { ScheduleChooseCreditCardWrapper } from './schedulingPayment/ScheduleChooseCreditCardWrapper/ScheduleChooseCreditCardWrapper';

export const useSchedulingSteps = () => {
  const { t, i18n } = useTranslation(['schedule', 'creditCard']);
  const schedulingSteps: Array<SchedulingStepsInterface> = [
    {
      pageLoading: SchedulingListUser,
      title: t('schedule_title'),
      subTitle: t('schedule_choose_user_subtitle'),
    },
    {
      pageLoading: SchedulingTypeAppointmentList,
      title: t('schedule_title'),
      subTitle: t('schedule_choose_appointment_in_person_location_title'),
      nextPopUp: true,
    },
    {
      pageLoading: SchedulingDoctorsList,
      title: t('schedule_title'),
      subTitle: t('schedule_choose_doctor_title'),
    },
    {
      pageLoading: SchedulingDateTime,
      title: t('schedule_title'),
      subTitle: t('screen_choose_confirm_schedule_date_time'),
    },
    {
      pageLoading: SchedulingPayment,
      title: t('schedule_title'),
      subTitle: t('screen_choose_payment_title'),
      addonNext: ScheduleChooseCreditCardWrapper,
    },
    {
      pageLoading: SchedulingConfirm,
      title: t('schedule_title'),
      subTitle: t('screen_choose_confirm_title'),
    },
  ];

  const addonSteps: Array<SchedulingStepsInterface> = [
    {
      pageLoading: ScheduleChooseCreditCardWrapper,
      title: t('creditCard:screen_credit_card_title'),
      subTitle: t('creditCard:screen_credit_card_subtitle'),
    },
  ];

  return useMemo(
    () => ({
      schedulingSteps,
      addonSteps,
    }),
    [i18n.language]
  );
};
